import React, { useState, useEffect, useCallback } from 'react';
import { fetchChildAllowanceSettings } from '../../../api';
import { useFamily } from '../../../context/FamilyContext';
import { currencies } from '../../basic/currencies';
import './AllowanceInfo.css';

const AllowanceInfo = React.memo(function AllowanceInfo({ childId, refreshTrigger }) {
    const [allowanceInfo, setAllowanceInfo] = useState({
        amount: '',
        frequency: '',
        day_of_distribution: '',
    });
    const { currencyCode } = useFamily();

    const getCurrencySymbol = useCallback(() => {
        const currency = currencies.find(c => c.code === currencyCode);
        return currency ? currency.symbol : '$'; // Default to '$' if not found
    }, [currencyCode]);

    const fetchAllowanceInfo = useCallback(() => {
        console.log("Fetching allowance info for childId:", childId);
        if (childId) {
            fetchChildAllowanceSettings(childId)
                .then(data => {
                    console.log("Fetched allowance info for childId:", childId, data);
                    setAllowanceInfo({
                        amount: data.amount,
                        frequency: data.frequency,
                        day_of_distribution: data.day_of_distribution,
                    });
                })
                .catch(error => console.error('Failed to fetch allowance info', error));
        }
    }, [childId]);

    useEffect(() => {
        fetchAllowanceInfo();
    }, [fetchAllowanceInfo, refreshTrigger]);

    const calculateDaysUntilNextDeposit = useCallback((distributionDay) => {
        const today = new Date();
        const todayDayOfWeek = today.getDay();
        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const distributionDayIndex = days.indexOf(distributionDay);

        let daysUntilNextDeposit = distributionDayIndex - todayDayOfWeek;
        if (daysUntilNextDeposit <= 0) {
            daysUntilNextDeposit += 7; // Ensure it's always a future event
        }

        return daysUntilNextDeposit;
    }, []);

    return (
        <div className="allowance-info-parent">
          <p className="allowance-item">Weekly Allowance: <strong>{getCurrencySymbol()}{allowanceInfo.amount}</strong> ({allowanceInfo.day_of_distribution})</p>
          <p className="allowance-item">Days to the next deposit: <strong>{calculateDaysUntilNextDeposit(allowanceInfo.day_of_distribution)}</strong></p>
        </div>
    );
});

export default AllowanceInfo;